export enum NoteScoreReason{
  IncorrectBecauseItWasNotPlayed,
  IncorrectBecauseItWasExtraneous,
  CorrectBecauseItWasPlayedWithinThreshold,
  CloseBecauseItWasTheRightPitchButWrongTime,
}